interface HistoryRetryPromptProps {
  message: string;
  onRetry: () => void;
}

export function HistoryRetryPrompt({ message, onRetry }: HistoryRetryPromptProps) {
  return (
    <>
      <p className="font-body text-body-3 text-text-tertiary">{message}</p>
      <button
        type="button"
        onClick={onRetry}
        className="font-body text-body-3 font-medium text-text-primary underline underline-offset-2 hover:opacity-80"
      >
        Try again
      </button>
    </>
  );
}
